export default __webpack_public_path__ + "static/media/10.8fda2d52.gif";